export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const TOKEN_REFRESHED = 'TOKEN_REFRESHED';
export const LOGOUT = 'LOGOUT';
